import * as React from "react";
import { CheckCircle2, Clock, XCircle, Loader2, AlertCircle } from "lucide-react";
import { Badge } from "./badge";
import { cn } from "@/lib/utils";

type Status = 'pending' | 'processing' | 'completed' | 'failed' | 'active' | 'inactive';

interface StatusConfig {
  label: string;
  variant: 'success' | 'warning' | 'error' | 'neutral' | 'primary';
  icon?: React.ReactNode;
}

const statusConfig: Record<string, StatusConfig> = {
  completed: {
    label: 'Completado',
    variant: 'success',
    icon: <CheckCircle2 size={12} />,
  },
  processing: {
    label: 'Procesando',
    variant: 'warning',
    icon: <Loader2 size={12} className="animate-spin" />,
  },
  pending: {
    label: 'Pendiente',
    variant: 'neutral',
    icon: <Clock size={12} />,
  },
  failed: {
    label: 'Fallido',
    variant: 'error',
    icon: <XCircle size={12} />,
  },
  active: {
    label: 'Activo',
    variant: 'primary',
    icon: <CheckCircle2 size={12} />,
  },
  inactive: {
    label: 'Inactivo',
    variant: 'neutral',
    icon: <AlertCircle size={12} />,
  },
};

interface StatusBadgeProps {
  status: Status | string;
  showIcon?: boolean;
  className?: string;
  colorHex?: string; // Color personalizado desde DB (sin #)
}

export function StatusBadge({ 
  status, 
  showIcon = false, 
  className,
  colorHex 
}: StatusBadgeProps) {
  const config = statusConfig[status.toLowerCase()] || {
    label: status,
    variant: 'neutral' as const,
  };

  // Si hay un color personalizado, usarlo
  if (colorHex) {
    const color = `#${colorHex}`;
    return (
      <span 
        className={cn(
          "inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border",
          className
        )}
        style={{ 
          backgroundColor: `${color}15`, // 15 en hex = ~8% opacidad
          color: color,
          borderColor: `${color}30`, // 30 en hex = ~19% opacidad
        }}
      >
        {showIcon && config.icon && (
          <span className="mr-1">{config.icon}</span>
        )}
        {config.label}
      </span>
    );
  }

  return (
    <Badge variant={config.variant} className={className}>
      {showIcon && config.icon && (
        <span className="mr-1">{config.icon}</span>
      )}
      {config.label}
    </Badge>
  );
}



